import type { NotificationPreferences } from '@central/api';

export type NotificationCategory = keyof NotificationPreferences;

/** Each category's switch label and what it covers, in display order. */
export const notificationCategories: Array<{
  key: NotificationCategory;
  label: string;
  description: string;
}> = [
  {
    key: 'conversations',
    label: 'Conversations',
    description: 'New messages and replies in support conversations.',
  },
  {
    key: 'incidents',
    label: 'Deployment health',
    description: 'Incidents opened and resolved on deployments.',
  },
  {
    key: 'licenses',
    label: 'Licenses',
    description: 'Licenses nearing expiry, and renewals.',
  },
  {
    key: 'releases',
    label: 'Releases',
    description: 'New releases, announcements and scheduled upgrades.',
  },
];
